import { Schema } from "@effect/schema";
import { Address, OracleKey, ProtocolKey } from "@silo/types";

export type MarketHeaderAsset = typeof MarketHeaderAsset.Type;
export type MarketHeaderAssetEncoded = typeof MarketHeaderAsset.Encoded;

export const MarketHeaderAsset = Schema.Struct({
  symbol: Schema.String,
  oracleKey: Schema.NullOr(OracleKey),
}).annotations({ identifier: "MarketHeaderAsset" });

export type MarketHeaderMarket = typeof MarketHeaderMarket.Type;
export type MarketHeaderMarketEncoded = typeof MarketHeaderMarket.Encoded;

export const MarketHeaderMarket = Schema.Struct({
  protocolKey: ProtocolKey,
  marketAddress: Address,
  marketSymbol: Schema.String,
  rawMarketSymbol: Schema.String,
  marketName: Schema.String,

  baseAsset: MarketHeaderAsset,
  bridgeAssets: Schema.Tuple(
    MarketHeaderAsset,
    Schema.optionalElement(MarketHeaderAsset)
  ),
}).annotations({ identifier: "MarketHeaderMarket" });
